import {applyMiddleware, createStore} from 'redux';
import immutableStateInvariant from 'redux-immutable-state-invariant';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import {routerMiddleware} from 'connected-react-router';
import rootReducer from './reducers/index';

export default function configureStore(history) {
  const middlewares = [
    thunkMiddleware,
    immutableStateInvariant(),
    routerMiddleware(history),
  ];
  const middlewareEnhancers = applyMiddleware(...middlewares);
  const enhancers = [middlewareEnhancers];
  const composedEnhancers = composeWithDevTools(...enhancers);
  const store = createStore(rootReducer, composedEnhancers);

  return store;
}
